import React, { useEffect, useState } from "react";
import "./Gallery.css";

export default function Gallery() {
  const [zoomedIndex, setZoomedIndex] = useState(null);

  const gallery = [
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_1.jpeg`,
      alt: "Sofa repair and restoration work",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_2.jpeg`,
      alt: "Premium sofa upholstery work",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_3.jpeg`,
      alt: "Professional sofa restoration",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_4.jpeg`,
      alt: "Sofa fabric replacement work",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_5.jpeg`,
      alt: "Custom sofa repair work",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_6.jpeg`,
      alt: "Sofa renovation project",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_7.jpeg`,
      alt: "Premium upholstery project",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_8.jpeg`,
      alt: "Sofa craftsmanship work",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_9.jpeg`,
      alt: "Furniture restoration project",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_10.jpeg`,
      alt: "Professional sofa service",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_11.jpeg`,
      alt: "Sofa makeover project",
    },
    {
      src: `${process.env.PUBLIC_URL}/img/sofa_12.jpeg`,
      alt: "Completed sofa restoration",
    },
    
   

  ];

  const openImage = (index) => {
    setZoomedIndex(index);
    document.body.style.overflow = "hidden";
  };

  const closeImage = () => {
    setZoomedIndex(null);
    document.body.style.overflow = "auto";
  };

  const showPrevious = (e) => {
    e.stopPropagation();

    setZoomedIndex((current) =>
      current === 0 ? gallery.length - 1 : current - 1
    );
  };

  const showNext = (e) => {
    e.stopPropagation();

    setZoomedIndex((current) =>
      current === gallery.length - 1 ? 0 : current + 1
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (zoomedIndex === null) {
        return;
      }

      if (e.key === "Escape") {
        closeImage();
      }

      if (e.key === "ArrowLeft") {
        setZoomedIndex((current) =>
          current === 0 ? gallery.length - 1 : current - 1
        );
      }

      if (e.key === "ArrowRight") {
        setZoomedIndex((current) =>
          current === gallery.length - 1 ? 0 : current + 1
        );
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [zoomedIndex, gallery.length]);

  return (
    <section className="gallery-section" id="gallery">
      <div className="gallery-container">

        {/* ================= HEADER ================= */}

        <div className="gallery-heading">

          <div className="gallery-eyebrow">
            <span></span>
            OUR CRAFTSMANSHIP
            <span></span>
          </div>

          <h2>
            Work That
            <strong> Speaks For Itself.</strong>
          </h2>

          <p>
            Take a look at some of our completed sofa repair,
            upholstery and restoration projects.
          </p>

        </div>

        {/* ================= GALLERY ================= */}

        <div className="gallery-grid">

          {gallery.map((item, index) => (
            <article
              className={`gallery-card gallery-card-${index + 1}`}
              key={index}
              onClick={() => openImage(index)}
            >
              <div className="gallery-image">

                <img
                  src={item.src}
                  alt={item.alt}
                  loading="lazy"
                />

                <div className="gallery-overlay">

                  <div className="gallery-view">
                    <span>VIEW</span>
                    <strong>+</strong>
                  </div>

                  <div className="gallery-overlay-bottom">
                    <span>RK SOFA WORKS</span>
                    <small>
                      {String(index + 1).padStart(2, "0")}
                    </small>
                  </div>

                </div>

                <div className="gallery-number">
                  {String(index + 1).padStart(2, "0")}
                </div>

              </div>
            </article>
          ))}

        </div>

        {/* ================= BOTTOM INFO ================= */}

        <div className="gallery-bottom">

          <div className="gallery-bottom-line"></div>

          <p>
            Every project is handled with attention to detail,
            quality materials and practical craftsmanship.
          </p>

          <div className="gallery-bottom-line"></div>

        </div>

      </div>

      {/* ================= LIGHTBOX ================= */}

      {zoomedIndex !== null && (
        <div
          className="gallery-lightbox"
          onClick={closeImage}
        >

          <button
            className="gallery-close"
            onClick={closeImage}
            aria-label="Close image"
          >
            ×
          </button>

          <button
            className="gallery-prev"
            onClick={showPrevious}
            aria-label="Previous image"
          >
            ‹
          </button>

          <div
            className="gallery-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >

            <img
              src={gallery[zoomedIndex].src}
              alt={gallery[zoomedIndex].alt}
            />

            <div className="gallery-lightbox-info">

              <span>
                RK SOFA WORKS
              </span>

              <strong>
                {String(zoomedIndex + 1).padStart(2, "0")}
                {" / "}
                {String(gallery.length).padStart(2, "0")}
              </strong>

            </div>

          </div>

          <button
            className="gallery-next"
            onClick={showNext}
            aria-label="Next image"
          >
            ›
          </button>

        </div>
      )}
    </section>
  );
}
